import { BIModel } from './BIModel';

export class StartSessionBIModel extends BIModel {

    static eventName = 'start_session';

    constructor(userId) {
        super(StartSessionBIModel.eventName, userId);
    }

    get modelData() {
        return {};
    }

}